import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid } from "@material-ui/core";
import { Block, Done } from "@material-ui/icons";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { TYPE_GLOBAL_PROPOTIES_CANCEL_REASON } from "app/common/LocalConst";
import { pagingExtGlobalProperty } from "app/services/GlobalPropertyService";
import CommonButton from "app/common/Component/Button/CommonButton";
import ReasonCancelCreateOrEdit from "app/Management/ManageConcept/ReasonCancel/ReasonCancelCreateOrEdit";
import AddIcon from "@material-ui/icons/Add";
import { useStore } from "app/stores";
import * as Yup from "yup";
function CancelInvoicePopup({ open, handleClose, onConfirm }) {
  const { handleOpenFormCreateOrEditReasonCancel } =
    useStore().managementStore.reasonCancelStore;
  return (
    <PopupForm
      size="sm"
      open={open}
      handleClose={handleClose}
      title="Xác nhận hủy hóa đơn"
      formik={{
        initialValues: {
          cancelReason: null,
        },
        validationSchema: Yup.object({
          cancelReason: Yup.object()
            .nullable()
            .required("Vui lòng chọn lý do hủy."),
        }),
        onSubmit: (values, { resetForm }) => {
          onConfirm(values.cancelReason);
          resetForm();
        },
      }}
      action={(values, isSubmitting) => {
        return (
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "8px",
            }}
          >
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" />
              Hủy
            </CommonButton>
            <CommonButton
              type="submit"
              className="btn-danger"
              disabled={isSubmitting}
            >
              <Done className="mr-2" />
              Xác nhận
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values, isSubmitting }) => {
        return (
          <>
            <div
              style={{
                marginBottom: "6px",
                fontWeight: 500,
                fontSize: "15px",
                color: "#333",
                lineHeight: "1.4",
              }}
            >
              {/* Vui lòng nhập lý do hủy thanh toán */}
            </div>
            <Grid item xs={12} className="flex gap-2 align-end">
              <GlobitsPagingAutocomplete
                name={"cancelReason"}
                label="Lý do hủy"
                required
                searchObject={{
                  dataType: TYPE_GLOBAL_PROPOTIES_CANCEL_REASON,
                  isActive: true,
                }}
                api={pagingExtGlobalProperty}
                getOptionLabel={(option) => option?.propertyValue || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.property === value?.property
                }
                onChange={(_, value) => {
                  setFieldValue("cancelReason", value);
                }}
              />

              <CommonButton
                className="btn-primary"
                onClick={() => {
                  handleOpenFormCreateOrEditReasonCancel();
                }}
              >
                <AddIcon />
              </CommonButton>
            </Grid>
            <ReasonCancelCreateOrEdit
              handleAfterSubmit={(data) => {
                setFieldValue("cancelReason", data);
              }}
            />
          </>
        );
      }}
    </PopupForm>
  );
}

export default memo(observer(CancelInvoicePopup));
